import React from 'react'
import { IconButton, Box, Typography } from '@material-ui/core'
import { FileCopy as FileCopyIcon } from '@material-ui/icons'
import { useSnackbar } from 'notistack'

import { ICorporation } from '../../../graphql/types/businesses'

interface IProps {
  item: ICorporation
}

export const TokenColumn: React.FC<IProps> = ({ item }) => {
  const { enqueueSnackbar } = useSnackbar()

  const handleCopy = async (token: string) => {
    try {
      await navigator.clipboard.writeText(token)
      enqueueSnackbar('Код скопирован')
    } catch (error) {
      enqueueSnackbar('Не удалось скопировать код')
    }
  }

  return (
    <Box display='flex' gridGap={8} alignItems='center'>
      <Typography>{item.token}</Typography>
      <IconButton size='small' onClick={() => handleCopy(item.token)}>
        <FileCopyIcon fontSize={'inherit'} color='disabled' />
      </IconButton>
    </Box>
  )
}
